var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"frame-item",attrs:{"src":_vm.computedSrc,"frameborder":"0"},on:{"load":_vm._onLoadHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }